import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { OriginState } from './origin.types';

const initialState: OriginState = {
  originUrl: {},
};

const originSlice = createSlice({
  initialState,
  name: 'origin',
  reducers: {
    removeOriginUrl(state, action: PayloadAction<string>) {
      delete state.originUrl[action.payload];
    },
    setOriginUrl(state, action: PayloadAction<{ key: string; value: string }>) {
      const { key, value } = action.payload;

      state.originUrl[key] = encodeURI(value);
    },
  },
});

export const { actions: originAction } = originSlice;

export default originSlice.reducer;
